




















































import * as _ from 'lodash';
import hash from 'object-hash';
import { listFactory } from '@/main/pages';
// eslint-disable-next-line no-unused-vars
import { Cell, Table } from '@/main/utils/table';

import { NAME, TAB_NAMES, tabItems, ZPRAVA_DRUH } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	data() {
		return {
			tabItems,
			tabNames: TAB_NAMES,
			dmsTabs: [],
			rules: {
				PrijemceIds: { required: true },
			},
		};
	},
	created() {
		this.activeTabName = TAB_NAMES.ZPRAVY;
		this.getZpravyCount();
		this.loggedUserId = this.loggedUser.UzivatelData.PracovnikId;
	},
	computed: {
		saveEnabled(): boolean {
			return hash(this.zprava) !== this.hash;
		},
		visibleButtons(): object {
			return {
				odeslat: this.isNovaZprava,
				ulozit: !this.isNovaZprava,
				odpovedet: !this.isNovaZprava && this.zpravyDruhEnum as ZPRAVA_DRUH === ZPRAVA_DRUH.ZPRAVY,
				odpovedetVsem: !this.isNovaZprava && this.zpravyDruhEnum !== ZPRAVA_DRUH.SYSTEMOVA_UPOZORNENI,
				vyridit: !this.isNovaZprava && !this.zprava.ZpracovanoPrpZkt && this.zpravyDruhEnum !== ZPRAVA_DRUH.ODESLANE
					&& this.zpravyDruhEnum !== ZPRAVA_DRUH.SYSTEMOVA_UPOZORNENI,
				aktivovat: !this.isNovaZprava && !!this.zprava.ZpracovanoPrpZkt && this.zpravyDruhEnum !== ZPRAVA_DRUH.ODESLANE
					&& this.zpravyDruhEnum !== ZPRAVA_DRUH.SYSTEMOVA_UPOZORNENI,
				doPoznamek: !this.isNovaZprava && this.zpravyDruhEnum !== ZPRAVA_DRUH.POZNAMKY,
				novaPoznamka: !this.isNovaZprava && this.zpravyDruhEnum === ZPRAVA_DRUH.POZNAMKY,
				predatDal: !this.isNovaZprava,
				zavritDetail: true,
			};
		},
		visibleVyrizene(): boolean {
			return this.zpravyDruhEnum !== ZPRAVA_DRUH.SYSTEMOVA_UPOZORNENI;
		},
		visibleStitek(): boolean {
			return !this.isNovaZprava && this.zpravyDruhEnum !== ZPRAVA_DRUH.ODESLANE && this.zpravyDruhEnum !== ZPRAVA_DRUH.SYSTEMOVA_UPOZORNENI;
		},
		validatorZprava(): Function {
			return (this.$refs.zpravaForm as any).validate;
		},
	},
	watch: {
		async activeTabName(newValue, oldValue) {
			if (newValue && oldValue) {
				try {
					this.zavritDetail();
					this.table = new Table({ });
					this.initFilter(_.get(this.tabItems, newValue).druh);
					this.startLoading();
					await Promise.all([this.loadData(), this.getZpravyCount()]);
				} finally {
					this.endLoading();
				}
			}
		},
	},
	methods: {
		async loadFilter() {
			return Promise.resolve();
		},
		initFilter(druh: ZPRAVA_DRUH) {
			this.zpravyDruhEnum = druh;
			this.vyrizene = druh === ZPRAVA_DRUH.ODESLANE ? null : false;
		},
		currentChange(cells: Cell[]) {
			const { druh } = _.get(this.tabItems, this.activeTabName);
			const zaznamId = cells[this.table.cellNames!.ZAZNAM_ID];
			const dmsUserMessageId = cells[this.table.cellNames!.DMSUSER_MESSAGE_ID];
			this.nactiZpravu({ druh, zaznamId, dmsUserMessageId });
			this.visibleDetail = true;
		},
		refreshTable() {
			this.zavritDetail();
			this.refreshFun();
		},
		async handleUlozit() {
			await this.ulozitZpravu();
			this.refreshFun();
		},
		async validateZprava() {
			let isValid;
			this.validatorZprava((valid: boolean) => {
				isValid = valid;
			});
			return isValid;
		},
		async handleOdeslat() {
			const isValid = await this.validateZprava();
			if (!isValid) {
				return new Error('Data are not valid');
			}
			return this.odeslatZpravu();
		},
		async handleVyriditAktivovat(vyridit: boolean) {
			await this.vyriditAktivovatZpravu(vyridit);
			await this.getZpravyCount();
			if (!_.isNil(this.vyrizene)) {
				this.refreshTable();
			}
		},
	},
});
